import {Component, input, model} from '@angular/core';
import {Dialog} from 'primeng/dialog';
import {TranslocoDirective, TranslocoPipe} from '@jsverse/transloco';
import {Button} from 'primeng/button';
import {InvoiceDataResponse} from '@frontend/shared-api';

@Component({
  selector: 'app-invoice-data-dialog',
  imports: [Dialog, TranslocoPipe, TranslocoDirective, Button],
  templateUrl: './invoice-data-dialog.component.html',
})
export class InvoiceDataDialogComponent {
  visible = model<boolean>(false);
  invoiceData = input<InvoiceDataResponse | null>(null);

  close(): void {
    this.visible.set(false);
  }
}
